import LNB from '@/components/common/LNB';
import Space from '@/components/Space';
import { ROLE, Role } from '@/constants/role';

type Props = {
  bizType: string;
  companyName: string;
  subCompanyName: string;
  role: Role;
  highlightedQuery: string;
  selected: boolean;
  onClick?: () => void;
};

const LNBAccountSearchItem = ({
  bizType,
  companyName = '',
  subCompanyName,
  role,
  highlightedQuery,
  selected,
  onClick
}: Props) => {
  const escapedQuery = highlightedQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${escapedQuery})`, 'gi');
  const splitedCompanyName = companyName.split(regex).filter((word) => word !== '');

  return (
    <LNB.AccountSearchItem onClick={onClick} selected={selected}>
      <div className="wrap_txt">
        <span className="txt_option">
          ({bizType})<Space />
          {splitedCompanyName.map((word, idx) => (word === highlightedQuery ? <em key={idx}>{word}</em> : word))}
        </span>
        <span className="txt_option1">{subCompanyName}</span>
      </div>

      <div className="opt_state">
        <span className="ico_badge ico_master">{ROLE[role]}</span>
      </div>
    </LNB.AccountSearchItem>
  );
};

export default LNBAccountSearchItem;
